import script from "./saleDetailReceive.vue?vue&type=script&setup=true&lang=js"
export * from "./saleDetailReceive.vue?vue&type=script&setup=true&lang=js"

import "./saleDetailReceive.vue?vue&type=style&index=0&id=17ce0ff4&lang=less"

const __exports__ = script;

export default __exports__